import React from "react";

function StarterIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        fill="#EAECF0"
      />
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        stroke="#667085"
      />
      <path
        d="M7.60009 17.9323C7.41085 17.9329 7.22532 17.8799 7.06504 17.7793C6.90477 17.6787 6.77632 17.5346 6.69464 17.3639C6.61296 17.1933 6.58138 17.0029 6.60359 16.8149C6.6258 16.627 6.70087 16.4493 6.82009 16.3023L16.7201 6.10229C16.7944 6.01657 16.8955 5.95865 17.0071 5.93802C17.1186 5.9174 17.2338 5.9353 17.3338 5.9888C17.4338 6.04229 17.5127 6.12819 17.5574 6.2324C17.6022 6.33661 17.6102 6.45294 17.5801 6.56229L15.6601 12.5823C15.6035 12.7338 15.5845 12.8968 15.6047 13.0573C15.6249 13.2178 15.6837 13.371 15.7762 13.5037C15.8686 13.6365 15.9919 13.7448 16.1354 13.8195C16.2789 13.8941 16.4383 13.9328 16.6001 13.9323H23.6001C23.7893 13.9316 23.9749 13.9847 24.1351 14.0853C24.2954 14.1859 24.4239 14.3299 24.5055 14.5006C24.5872 14.6713 24.6188 14.8617 24.5966 15.0496C24.5744 15.2376 24.4993 15.4153 24.3801 15.5623L14.4801 25.7623C14.4058 25.848 14.3046 25.9059 14.1931 25.9266C14.0816 25.9472 13.9664 25.9293 13.8664 25.8758C13.7664 25.8223 13.6875 25.7364 13.6428 25.6322C13.598 25.528 13.59 25.4116 13.6201 25.3023L15.5401 19.2823C15.5967 19.1308 15.6157 18.9678 15.5955 18.8073C15.5753 18.6468 15.5164 18.4936 15.424 18.3609C15.3316 18.2281 15.2083 18.1198 15.0648 18.0451C14.9213 17.9705 14.7618 17.9318 14.6001 17.9323H7.60009Z"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default StarterIcon;
